import React from "react"

export default ({ refId }) => (
  <a className="ref" id={`return-ref-${refId}`} href={`#ref-${refId}`}>
    <sup>{refId}</sup>
  </a>
)
